// @ts-nocheck


import React, { useMemo } from 'react';

import { Wrapper, Pie } from './styles';






/**
 * Мини-карта статусов трека
 */
export const TrackHistory = ({ intervals }) => {
  const pies = useMemo(() => {
    return intervals.map(({ width, status }, index) =>
    <Pie key={index} style={{ width }} status={status} />
    );
  }, [intervals]);

  return <Wrapper>{pies}</Wrapper>;
};
